import { z } from "zod";

export const validate = (schema: z.ZodSchema, value: any) => {
  const result = schema.safeParse(value);
  if (!result.success) {
    return result.error.issues[0]?.message;
  }
  return undefined;
};
